import { v4 as uuidv4 } from "uuid";
import { MessageTypes } from "@app/pippa/models";
import type { EventDataMessageType } from "@app/pippa/models";
import type { ChatActionMessage } from "@app/pippa/hooks/useApiController";

export function buildActionMessages(
  messages: ChatActionMessage[]
): EventDataMessageType[] {
  return messages.map((msg) => ({
    id: uuidv4(),
    type: MessageTypes.TEXT,
    text: msg.content,
    isSendByUser: false,
    quickReplies: msg.quickReplies,
  }));
}
